import classnames from 'classnames';
import mermaid, { RenderResult } from 'mermaid';
import React from 'react';

import { useThemeContext } from 'src/components/themeProvider/ThemeProvider';

import { mermaidDarkTheme, mermaidLightTheme } from '../mermaidThemes';

const MERMAID_DOM_ID = 'mermaidQueryPlan';

mermaid.initialize({
  startOnLoad: false,
  securityLevel: 'strict',
  arrowMarkerAbsolute: false,
  flowchart: {
    htmlLabels: true,
    curve: 'basis',
    useMaxWidth: true,
  },
  theme: 'default',
});

export const useMermaidRender = (nodeString: string | undefined = '') => {
  const [mermaidRender, setMermaidRender] = React.useState<RenderResult>();
  const { themedValue } = useThemeContext();

  React.useEffect(() => {
    let ignore = false;
    if (nodeString) {
      /**
       * Mermaid does not work with css variables, so we have to handle the themes based on mode manually
       */
      mermaid.init({
        themeVariables: themedValue({
          dark: mermaidDarkTheme,
          light: mermaidLightTheme,
        }),
      });
      mermaid.render(MERMAID_DOM_ID, nodeString).then((result) => {
        if (!ignore) {
          setMermaidRender(result);
        }
      });
    }
    return () => {
      ignore = true;
    };
  }, [nodeString, themedValue]);

  return mermaidRender?.svg;
};

export const Mermaid = ({
  mermaidSVGText = '',
  className,
}: {
  mermaidSVGText: string | undefined;
  className?: string;
}) => (
  <div
    className={classnames(className, 'overflow-auto text-center')}
    // TODO (jason) do we trust mermaid enough for this?
    // eslint-disable-next-line react/no-danger
    dangerouslySetInnerHTML={{ __html: mermaidSVGText }}
  />
);
